export * from './main';
export * from './constants';
import * as PartsOfSpeech from './constants';

import { List } from 'immutable';

export const PARTS_OF_SPEECH = List([
  PartsOfSpeech.NOUN,
  PartsOfSpeech.NOUN_ABBREVIATION,
  PartsOfSpeech.VERB,
  PartsOfSpeech.ADJECTIVE,
  PartsOfSpeech.ADVERB,
  PartsOfSpeech.PHRASAL_VERB,
  PartsOfSpeech.PHRASE,
  PartsOfSpeech.PREPOSITION,
  PartsOfSpeech.PROPER_NOUN,
  PartsOfSpeech.VERBAL_NOUN,
  PartsOfSpeech.ADJECTIVAL_NOUN,
  PartsOfSpeech.PRONOUN,
  PartsOfSpeech.AUXILIARY_VERB,
  PartsOfSpeech.CONJUNCTION,
  PartsOfSpeech.INTERROGATIVE,
  PartsOfSpeech.INTERJECTION,
  PartsOfSpeech.PARTICLE,
  PartsOfSpeech.DETERMINER,
]);

export function getPartOfSpeechByCode(code: string) {
  return PARTS_OF_SPEECH.find((pos) => (pos.metadata.code === code));
}
